/**
 * Attaches relevant forms to allow editing of object properties in place.
 *
 * Requires a container element that's loaded via c2.include module (i.e. the
 * element has `data-include` attribute). Inside the container can be any
 * number of editable items. The container content should include a call to
 * initialize inline edits every time it's loaded:
 *     c2.inlineEdits.init()
 *
 * Each editable item is defined by having a "data-inline-form-url" attribute
 * with the URL for that form view.
 *
 * An editable will automatically get an edit icon appended (with class
 * "revealable" that can be used to show it on hover). This icon gets a click
 * handler which loads the form and inserts it into the DOM immediately after
 * the icon.
 *
 * See templates/servers/panel-organization.html for an example.
 */

(function (c2) {
  'use strict';

  var $origContent;


  /**
   * Set up inline edits inside the given container selector or jQuery object.
   *
   * Editable elements have data-inline-form-url attribute, which is the URL from which to load the form.
   */
  function init(container) {
    var $container = $(container);

    $container.find('[data-inline-form-url]').each(function() {
      var $editable = $(this);
      var $link = $('<a href="#" class="inline-edit-link revealable"><i class="bi bi-pencil-fill"></i></a>');

      $link.on('click', loadForm);
      $editable.append($link);
    });
  }


  /**
   * Load the form for making an inline edit.
   */
  function loadForm(e) {
    e.preventDefault();

    var $form;
    var $editable = $(this).closest('[data-inline-form-url]');
    var url = $editable.data('inline-form-url');

    $.get(url, function (response) {
      if (response.errorMessage) {
        c2.alerts.addGlobalAlert(response.errorMessage, 'error', true, 5000);
      } else {
        $origContent = $editable.children();
        $origContent.hide();

        // Prevent edit links from showing up while an inline edit is taking place
        $editable.closest('.revealer').find('a.inline-edit-link').hide();

        $form = $(response.content);
        setupInlineForm($form, url);
        $editable.append($form);

        $editable.trigger('cb.inlineEdits.loaded');
      }
    });
  }

  /**
   * Set up event handlers for newly loaded inline form.
   */
  function setupInlineForm($form, url) {

    $form.on('click', '[data-btn-save]', function(e) {
      e.preventDefault();
      submitForm($form, url);
    });

    $form.on('click', '[data-btn-cancel]', function(e) {
      e.preventDefault();
      closeInlineForm($form);
    });

    $form.on('keypress', function(e) {
      var key = e.key || e.keyCode;

      if (key == 'Enter' || key == 13) {
        e.preventDefault();

        if ('data-btn-save' in e.target.attributes) {
          submitForm($form, url);
        }
        if ('data-btn-cancel' in e.target.attributes) {
          closeInlineForm($form);
        }
      }
    });

    $(document).on('keydown', function(e) {
      var key = e.key || e.keyCode;

      if (key == 'Escape' || key == 27) {
        closeInlineForm($form);
        e.preventDefault();
      }
    });
  }


  function closeInlineForm($form) {
    var $editable = $form.closest('[data-inline-form-url]');

    $form.remove();
    $origContent.show();

    // Restore the edit links reveal-on-hover behavior
    $editable.closest('.revealer').find('a.inline-edit-link').show();

    // Close all tooltips so they don't stick around
    $('#tooltip-container').html('');

    $editable.trigger('cb.inlineEdits.closed');
  }


  function submitForm($form, url) {
    var $includeContainer = $form.closest('[data-include]');
    var fadeOutMs;

    c2.spinners.showSpinner({selector: $form, fade: true});

    // Close all tooltips so they don't stick around
    $('#tooltip-container').html('');

    $.post(url, $form.serializeArray(), function(response) {
      $form.remove();

      $(document).trigger('cb.inlineEdits.closed');

      if (response.status == 'success') {
        fadeOutMs = 5000;

        // Load the entire container to show the new content
        c2.include.reload($includeContainer);
      }

      if (response.alert) {
        c2.alerts.addGlobalAlert(response.alert, response.status, true, fadeOutMs);
      }

      c2.spinners.hideSpinner({selector: $form, fade: true});

    });
  }

  c2.inlineEdits = {
    init: init
  };
})(window.c2);
